import { z } from 'zod';
import { BankAccountPayload, BaseBankAccountPayloadSchema } from './bank-account.payload.entity';

export const SwiftBankAccountPayloadSchema = BaseBankAccountPayloadSchema.merge(
    z.object({
        accountNumber: z.string().regex(/^[a-zA-Z0-9\\s]{4,34}$/, { message: 'IBAN should contain 4 to 34 letters or digits' }),
        swiftCode: z.string().regex(/^[a-zA-Z]{6}(([a-zA-Z0-9]{2})|([a-zA-Z0-9]{5}))$/, {
            message: 'Invalid input. It should start with 6 alphabetic characters followed by either 2 or 5 alphanumeric characters.',
        }),
    }),
);

export class SwiftBankAccountPayload extends BankAccountPayload {
    swiftCode: string;
    accountNumber: string;
}
